(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsen-shared/assets/javascripts/tipsen-shared.js') >= 0) return;  svs.modules.push('/components/sport/tipsen-shared/assets/javascripts/tipsen-shared.js'); "use strict";

const CouponQueryParams = {
  PARAM_BET_AMOUNT: 'bet_amount',
  PARAM_WEEK: 'week',
  PARAM_SPORTKRYSS: 'sportkryss',
  PARAM_SPORTKRYSS_NUMBER: 'sportkryss_number',
  PARAM_SIGNS: 'signs',
  PARAM_SYSTEM_TYPE: 'system_type',
  PARAM_SYSTEM: 'system'
};
const PARAM_MARKETPLACE_GAME_ID = 'activatedDrawId';
const ParticipantType = {
  Player: 'Player',
  Team: 'Team'
};
const EventTypeId = {
  EVENT_1X2: 1,
  HALFTIME_FULLTIME: 2,
  RESULT: 3,
  OVER_UNDER: 4,
  DOUBLECHANCE: 5,
  HANDICAP: 6,
  WINNER: 7,
  FIRST_GOAL_SCORER: 8,
  DUEL: 9,
  PLACING: 10,
  FORECAST: 11,
  HEAD_TO_HEAD: 12,
  LAST_GOAL_SCORER: 13,
  GOALS_BY_TEAM: 14,
  GOALS_BY_PLAYER: 15,
  AMOUNT: 16,
  PENALTY_GOALS: 18,
  PROFIT_MARGIN: 19,
  ODD_EVEN: 20,
  ALL_COMB_HOLDERS: 21,
  ALL_COMB_PARTICIPANTS: 24,
  GOAL_COUNT: 25,
  FIRST_GOAL: 26,
  LAST_GOAL: 27,
  LEAST_AMOUNT_OF_GOALS: 28,
  WIN_WITH_ZEROING: 29,
  EVENT_1X2_OVER_UNDER: 30,
  EVENT_1_2: 31,
  SCORECAST: 32
};
const SubProductId = {
  NONE: 0,
  EUROPATIPSET: 1,
  BRASILIANSKA_TIPSET: 2,
  VM_TIPSET: 3,
  EM_TIPSET: 4,
  VINN2: 5,
  VINN3: 6,
  VINN4: 7,
  VINN5: 8,
  RX1W: 9,
  RX1P: 10,
  RX2AO: 11,
  RX2IO: 12,
  RX2P: 13,
  RX5IO: 14,
  RX4IO: 15,
  RX3AO: 16,
  RX3IO: 17,
  RX3IOAO: 18,
  RX2P4: 19,
  RX1WINT: 20,
  RX2IOINT: 21,
  RX3IOINT: 22
};
const DrawState = {
  Undefined: 0,
  Defined: 1,
  Opened: 2,
  Regclosed: 3,
  Cancelclosed: 4,
  ResultEntered: 5,
  ResultVerified: 6,
  WincountStarted: 7,
  WincountFailed: 8,
  WincountDone: 9,
  WinvaluesEntered: 10,
  WinvaluesVerified: 11,
  WingenStarted: 12,
  WingenFailed: 13,
  WingenDone: 14,
  WinpayoutStarted: 15,
  WinpayoutFailed: 16,
  PublishStarted: 17,
  PublishFailed: 18,
  PublishDone: 19,
  Finalized: 20
};
const UserProduct = {
  EmTipset: 'EmTipset',
  VmTipset: 'VmTipset'
};
const subProductId2ToDisplayName = {
  [SubProductId.EUROPATIPSET]: 'Europatipset',
  [SubProductId.EM_TIPSET]: 'EM-Tipset',
  [SubProductId.VM_TIPSET]: 'VM-Tipset'
};
const userProduct2SubProductId = {
  Europatipset: SubProductId.EUROPATIPSET,
  EmTipset: SubProductId.EM_TIPSET,
  VmTipset: SubProductId.VM_TIPSET
};

const createEventStatisticsKey = _ref => {
  let {
    matchId,
    eventTypeId = EventTypeId.EVENT_1X2,
    participantIds = []
  } = _ref;

  if (eventTypeId === EventTypeId.EVENT_1X2 || !participantIds.length) {
    return "".concat(matchId, "_").concat(EventTypeId.EVENT_1X2);
  }

  return "".concat(matchId, "_").concat(eventTypeId).concat(participantIds.length ? '_'.concat(participantIds.join('_')) : '');
};

const getSubProductDisplayName = subProductId => {
  const displayName = subProductId2ToDisplayName[subProductId];

  if (!displayName) {
    return '';
  }

  return displayName;
};

const signIndexToOutcome = {
  0: '1',
  1: 'X',
  2: '2'
};
const outcomeToSignIndex = {
  1: 0,
  X: 1,
  2: 2
};
const oneXTwoStringDelimiter = ':';

const convert1X2SignsTo1X2String = (oneXTwoString, uRow) => oneXTwoString.map((oneXTwo, index) => {
  var _oneXTwo;

  const isM = ((_oneXTwo = oneXTwo[oneXTwo.length - 1]) === null || _oneXTwo === void 0 ? void 0 : _oneXTwo.toUpperCase()) === 'M';

  if (isM) {
    oneXTwo = oneXTwo.slice(0, -1);
  }

  return index + 1 + oneXTwoStringDelimiter + (isM ? 'M' : '') + oneXTwo.toUpperCase().split('').map(x => {
    let uPrefix = null;

    if (Array.isArray(uRow)) {
      uPrefix = uRow[index] === x;
    }

    return (uPrefix ? 'U' : '') + x;
  }).join('');
}).join(',');

const convertSignsTo1X2String = signs => signs.map((s, index) => {
  const concatenatedSigns = s.map((v, i2) => {
    if (v) {
      return signIndexToOutcome[i2];
    }

    return false;
  }).filter(Boolean).join('');

  if (concatenatedSigns === '') {
    return false;
  }

  return "".concat(index + 1).concat(oneXTwoStringDelimiter).concat(concatenatedSigns);
}).filter(Boolean).join(',');

const convert1X2StringToSigns = (oneXtwo, size) => {
  const events = oneXtwo.toUpperCase().split(',');
  const signs = new Array(size);
  const uSigns = new Array(size).fill(null);
  const mSigns = new Array(size).fill(false);

  for (let i = 0; i < signs.length; ++i) {
    signs[i] = [false, false, false];
  }

  for (const event of events) {
    let [eventNumber, v] = event.split(oneXTwoStringDelimiter);
    eventNumber = Number(eventNumber);

    if (eventNumber > size) {
      continue;
    }

    if (v[0] === 'M') {
      mSigns[eventNumber - 1] = true;
      v = v.slice(1);
    }

    const chars = v.split('');
    chars.forEach((d, charIndex) => {
      const index = outcomeToSignIndex[d];

      if (index !== undefined) {
        const prevSign = chars[charIndex - 1];

        if (uSigns[eventNumber - 1] === null && !mSigns[eventNumber - 1] && prevSign === 'U') {
          uSigns[eventNumber - 1] = index;
        }

        signs[eventNumber - 1][index] = true;
      }
    });
  }

  return {
    signs,
    mSigns,
    uSigns
  };
};

const TipsenModuleGameUrl = {
  STANDARD: '',
  SYSTEM: 'systemspel',
  PIX: 'pix',
  MARKETPLACE: 'andelar',
  SINGLES: 'enkelrader',
  EXTERNAL: 'externa-systemspel',
  TIPSM: 'tips-sm'
};
const ReducerState = {
  Init: 'REDUCER_STATE_INIT',
  Pending: 'REDUCER_STATE_PENDING',
  Rejected: 'REDUCER_STATE_REJECTED',
  Done: 'REDUCER_STATE_DONE'
};
const BigStatPathname = {
  News: 'nyheter',
  Table: 'tabell',
  Statistic: 'statistik',
  Lineup: 'laguppstallning',
  Analyze: 'speltips'
};
const SportId = {
  Fotball: 1000002,
  Hockey: 1000003,
  Tennis: 1000007,
  Floorball: 1000006,
  TableTennis: 1000022,
  Speedway: 1000009,
  Futsal: 1000047,
  Volleyball: 1000049,
  CrossCountrySkiing: 1000018,
  Snooker: 1000033,
  Motorsport: 1000053,
  Handball: 1000005,
  Bandy: 1000004,
  Golf: 1000008,
  Rugby: 1000017,
  Basket: 1000011,
  Music: 1000019,
  Formula1: 1000015
};
const SportIdToString = {
  [SportId.Fotball]: 'fotboll',
  [SportId.Hockey]: 'ishockey',
  [SportId.Tennis]: 'tennis',
  [SportId.Floorball]: 'innebandy',
  [SportId.TableTennis]: 'bordtennis',
  [SportId.Speedway]: 'speedway',
  [SportId.Volleyball]: 'volleyboll',
  [SportId.Motorsport]: 'motorsport',
  [SportId.Futsal]: 'futsal',
  [SportId.CrossCountrySkiing]: 'längdskidor',
  [SportId.Handball]: 'handboll',
  [SportId.Bandy]: 'bandy',
  [SportId.Golf]: 'golf',
  [SportId.Rugby]: 'rugby',
  [SportId.Basket]: 'basket',
  [SportId.Music]: 'musik',
  [SportId.Formula1]: 'formel 1'
};
const toExport = {
  ParticipantType,
  BigStatPathname,
  createEventStatisticsKey,
  convert1X2SignsTo1X2String,
  convert1X2StringToSigns,
  convertSignsTo1X2String,
  CouponQueryParams,
  EventTypeId,
  getSubProductDisplayName,
  outcomeToSignIndex,
  PARAM_MARKETPLACE_GAME_ID,
  ReducerState,
  signIndexToOutcome,
  SubProductId,
  DrawState,
  subProductId2ToDisplayName,
  TipsenModuleGameUrl,
  UserProduct,
  userProduct2SubProductId,
  SportId,
  SportIdToString
};

if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.sport.tipsenShared', toExport);
}
 })(window);